import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLang } from '../context/LangContext';
import { resolveImage } from '../config';

const LIVRAISON     = 15;
const SEUIL_GRATUIT = 150;
const fmt = (n) => n.toLocaleString() + ' TND';

const Cart = ({ isOpen, onClose }) => {
  const { items, total, dispatch } = useCart();
  const { t } = useLang();
  const navigate = useNavigate();

  const updateQty = (id, qty) => dispatch({ type: 'UPDATE_QTY', payload: { id, qty } });
  const remove    = (id)      => dispatch({ type: 'REMOVE_ITEM', payload: id });

  const fraisLivraison = total >= SEUIL_GRATUIT ? 0 : LIVRAISON;
  const totalFinal     = total + fraisLivraison;

  return (
    <>
      <div className={`cart-overlay ${isOpen ? 'cart-overlay--open' : ''}`} onClick={onClose} />
      <aside className={`cart-drawer ${isOpen ? 'cart-drawer--open' : ''}`}>
        <div className="cart-drawer__header">
          <h2>{t('cart_title')}</h2>
          <button className="cart-close-btn" onClick={onClose} aria-label="Close">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <div className="cart-empty__icon">🛒</div>
            <p>{t('cart_empty')}</p>
            <button className="btn btn--primary" onClick={onClose}>{t('cart_start')}</button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div className="cart-item" key={item.id}>
                  <img src={resolveImage(item.image)} alt={item.name} className="cart-item__img" />
                  <div className="cart-item__info">
                    <p className="cart-item__name">{item.name}</p>
                    <div className="cart-item__subtotal">
                      {(item.price * item.quantity).toLocaleString()} TND
                    </div>
                    <div className="cart-item__controls">
                      <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity - 1)}>−</button>
                      <span className="qty-value">{item.quantity}</span>
                      <button className="qty-btn" onClick={() => updateQty(item.id, item.quantity + 1)}>+</button>
                      <button className="remove-btn" onClick={() => remove(item.id)} aria-label="Remove">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="3 6 5 6 21 6"/>
                          <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                          <path d="M10 11v6M14 11v6"/>
                        </svg>
                      </button>
                    </div>
                    <div className="cart-item__unit-price">{item.price.toLocaleString()} TND / {t('cart_unit')}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-summary">
              <div className="cart-summary__row">
                <span>{t('cart_subtotal')}</span>
                <span>{fmt(total)}</span>
              </div>
              <div className="cart-summary__row">
                <span>{t('cart_shipping')}</span>
                <span className={fraisLivraison === 0 ? 'free-text' : ''}>
                  {fraisLivraison === 0 ? t('cart_shipping_free') : fmt(LIVRAISON)}
                </span>
              </div>
              <div className="cart-summary__divider" />
              <div className="cart-summary__row cart-summary__row--total">
                <strong>{t('cart_total')}</strong>
                <strong>{fmt(totalFinal)}</strong>
              </div>

              {total < SEUIL_GRATUIT && (
                <p className="free-shipping-hint">
                  {fmt(SEUIL_GRATUIT - total)} {t('cart_free_hint')}
                </p>
              )}

              <button className="btn btn--primary btn--full checkout-btn" onClick={() => { onClose(); navigate('/checkout'); }}>
                {t('cart_checkout')} — {fmt(totalFinal)}
              </button>
              <button className="btn btn--ghost btn--full" onClick={() => dispatch({ type: 'CLEAR_CART' })}>
                {t('cart_clear')}
              </button>
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export default Cart;
